<template>
  <div :class="['x-alert', props.type]">
    <ExclamationCircleFilled
      v-if="props.type === 'warning'"
      class="text-[#FFAC15] text-[16px] mt-[3px] mr-[8px]"
    />
    <span class="text-[#121926] info">
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  type: 'warning';
}>();
</script>

<style lang="scss" scoped>
.x-alert {
  display: flex;
  align-items: flex-start;
  padding: 9px 17px 7px 12px;
  font-size: 12px;
  line-height: 24px;
  border-radius: 8px;
  font-weight: 400;
  &.warning {
    background: var(--warning-1);
    border: 1px solid var(--warning-3);
  }
}
</style>
